import { useSettings } from '@/data/Settings';
import { setCookieCAPI } from 'presentation/events/utils/eventCookieUtils';
import { useCallback } from 'react';

import { useTrackSubscribeFacebook } from './useTrackSubscribeFacebook';
import { useTrackSubscribeTikTok } from './useTrackSubscribeTikTok';

export const useTrackSubscribe = () => {
	const { settings } = useSettings();
	const { storeId } = settings;

	const { sendFacebookEvent } = useTrackSubscribeFacebook();
	const { sendTiktokEvent } = useTrackSubscribeTikTok();

	return useCallback(() => {
		const eventId = setCookieCAPI('mfbt');

		sendFacebookEvent({ eventId, storeId });
		sendTiktokEvent({ eventId, storeId });
	}, [sendFacebookEvent, sendTiktokEvent, storeId]);
};
